(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('EditInvestorProfileForm', [
			'globalConfig',
			EditInvestorProfileFormFunction
		]);

	function EditInvestorProfileFormFunction(globalConfig) {
		var investorProfile = this;
		
		angular.merge(investorProfile, globalConfig);
		
		investorProfile.industryOptions = [
			'Real Estate',
			'Legal',
			'Management Consulting',
			'Financial Services & Banking',
			'Government',
			'Government Contracting',
			'Computer Software',
			'Healthcare',
			'Information Technology & Services',
			'Engineering',
			'Construction',
			'Marketing & Advertising',
			'PR & Communications',
			'Hospitality',
			'Retail',
			'Telecommunications',
			'Insurance',
			'Entertainment',
			'Biotechnology',
			'Small Business/Entrepreneur',
			'Other'
		];
		
		if (investorProfile.industry === '') {
			investorProfile.industry = investorProfile.industryOptions[0]; 
		}
	}
})(window.angular);